// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./Components/ProtectedRoute";
import Layout from "./Components/layout/Layout";
import LoginPage from "./pages/LoginPage/LoginPage";
import Dashboard from "./pages/Dashboardpage/Dashboard";
import Jobs from "./pages/Jobspage/Jobs";
import JobDetails from "./pages/Jobspage/JobDetails";
import Drivers from "./pages/Driverspage/Drivers";
import DriverDetails from "./pages/Driverspage/DriverDetails";
import Users from "./pages/Userspage/Users";
import UserDetails from "./pages/Userspage/UserDetails";
import Reviews from "./pages/Reviewspage/Reviews";
import DemoRequests from "./pages/DemoRequestspage/DemoRequests";
import Settings from "./pages/Settingspage/Settings";
import HelpSupport from "./pages/Helppage/Helpsupport";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import RouteOptimization from "./pages/RouteOptimizationpage/RouteOptimization";
import "./App.css";
import "./theme.css";

// Apply saved theme on load (before render to prevent flash)
const savedTheme = localStorage.getItem('mq_admin_theme') || 'light';
document.documentElement.setAttribute('data-theme', savedTheme);

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Navigate to="/dashboard" replace />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <ProtectedRoute>
                <Layout>
                  <Jobs />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <JobDetails />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/drivers"
            element={
              <ProtectedRoute>
                <Layout>
                  <Drivers />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/drivers/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <DriverDetails />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Layout>
                  <Users />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <UserDetails />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reviews"
            element={
              <ProtectedRoute>
                <Layout>
                  <Reviews />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/demo-requests"
            element={
              <ProtectedRoute>
                <Layout>
                  <DemoRequests />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <Layout>
                  <HelpSupport />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/route-optimization"
            element={
              <ProtectedRoute>
                <Layout>
                  <RouteOptimization />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/route-optimization/:driverId"
            element={
              <ProtectedRoute>
                <Layout>
                  <RouteOptimization />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Catch all - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
